import _ from "lodash";

const assets = {
  qatar_logo: require("../../../assets/wc/images/insight_zone_white.png"),
  background_1920: require("../../../assets/of/videos/background_1920x1080_v2.webm"),
};

export default assets;
